import React from 'react'
import { Card, CardContent, Typography } from "@mui/material";
import otherimg from '../asset/rule/other.png';
import cancelimg from '../asset/rule/cancel.png';
import matchedimg from '../asset/rule/matched.png';

export default function Rule() {

  type Content = {
    type: 'title' | 'subtitle' | 'text' | 'img',
    value: string
  }
  const contents: Content[] = [
    { type: 'title', value: 'はじめに' },
    { type: 'text', value: '本サービスは報告を基に勝敗を決定づける仕様上、ご利用者様の善意に頼って運用されています。' },
    { type: 'text', value: '以下に基本的なルールを示しますが、それ以上にマナーや節度を守ってご利用ください。' },
    { type: 'title', value: '対戦の始め方' },
    { type: 'text', value: '使用デッキを選択して対戦相手を検索します。' },
    { type: 'text', value: '使いたいデッキが候補にない場合は「その他」を選択してください。' },
    { type: 'img', value: otherimg },
    { type: 'text', value: '検索をやめる場合は必ずキャンセルを押してください。' },
    { type: 'text', value: 'マッチング処理に支障をきたして対戦せずにレートが下がる場合があります。' },
    { type: 'img', value: cancelimg },
    { type: 'text', value: '対戦相手が見つかったらチャットで挨拶をしましょう。' },
    { type: 'text', value: 'エリアが青く囲われているプレイヤーはルームを作成し、チャットでルームIDを伝えてください。' },
    { type: 'img', value: matchedimg },
    { type: 'title', value: '勝敗の決め方' },
    { type: 'text', value: '通信エラーを含めて、ゲームの判定に準拠します。' },
    { type: 'text', value: '引き分けになった場合は再戦してください。' },
    { type: 'text', value: 'その際、先攻後攻は先の試合に合わせる必要はありません。コイントスからやり直してください。' },
    { type: 'title', value: '例外対応' },
    { type: 'subtitle', value: '■ 対戦相手から連絡が来ない/来なくなった' },
    { type: 'text', value: '最後にチャットをしてから10分間連絡がないことを目安とし、不戦勝として勝ちの報告をしてください。' },
    { type: 'text', value: 'その際、先後はコイントスに勝った際に自分が選ぶものを選択してください。' },
    { type: 'subtitle', value: '■ 試合に勝った対戦相手が報告をしない' },
    { type: 'text', value: '前項と同様の対応をしてください。' },
    { type: 'subtitle', value: '■ 対戦相手が虚偽の報告を繰り返す' },
    { type: 'text', value: '3回連続で報告を否認すると無効試合となります。' },
    { type: 'text', value: '無効試合となった場合は対戦相手を通報することができます。' },
    { type: 'subtitle', value: '■ 対戦相手が報告を否認し続ける' },
    { type: 'text', value: '前項と同様の対応をしてください。' },
  ]

  return (
    <Card variant='outlined'>
      <CardContent>
        {contents.map((content, i) => (
          <React.Fragment key={i}>
            {content.type === 'title' &&
              <Typography sx={{mt: i === 0 ? 0 : 3}}>{content.value}</Typography>
            }
            {content.type === 'subtitle' &&
              <Typography
                sx={{ mt: contents[i-1].type === 'title' ? 0 : 2 }}
                variant='body2'
                color='text.secondary'
              >
                {content.value}
              </Typography>
            }
            {content.type === 'text' &&
              <Typography variant='body2' color='text.secondary'>{content.value}</Typography>
            }
            {content.type === 'img' &&
              <img
              alt=''
              src={content.value}
              width={192}
              style={{
                border: '1px solid #232323',
                marginTop: '4px',
                marginBottom: '8px',
              }}
            />
            }
          </React.Fragment>
        ))}
        <Typography>
        </Typography>
      </CardContent>
    </Card>
  )
}